import React from 'react';
import PageTitle from '@/ui/shared/components/pageTitle';

interface RecoverPasswordHeaderProps {
  headerText: string;
  subHeaderText: string;
}
const RecoverPasswordFormHeader: React.FC<RecoverPasswordHeaderProps> = ({
  headerText,
  subHeaderText,
}) => {
  return (
    <PageTitle className="mb-10 text-center">
      <span className={`mb-5 text-2xl font-bold text-primary `}>
        {headerText}
      </span>
      <span className={`block text-lg text-primary-pale`}>{subHeaderText}</span>
    </PageTitle>
  );
};

export default RecoverPasswordFormHeader;
